/**
 * Badge — Small label for counts, statuses, or notifications.
 *
 * Props:
 *   children: ReactNode — badge content
 *   variant: 'default' | 'success' | 'warning' | 'error' | 'info' | 'accent'
 *   size: 'sm' | 'md'
 */

import React from 'react';
import styles from './Badge.module.css';

function Badge({ children, variant = 'default', size = 'sm' }) {
  const classNames = [
    styles.badge,
    styles[variant],
    styles[size],
  ].join(' ');

  return <span className={classNames}>{children}</span>;
}

export default Badge;
